<template>
    <div class="container tercero-page">
        <div class="param-title-wrap">
            <b-button class="page-back-btn mr-2" variant="link" @click="goBack">
                <font-awesome-icon :icon="['fas', 'arrow-alt-circle-left']" />
            </b-button>
            <h2 class="param-title">{{labels.title}}</h2>
        </div>
        <div class="tercero-table-block mt-4" v-if="tipoActivo?.length > 0">
            <CorporateDataTable
                :items="tipoActivo"
                :fields="allFields"
                :filter-defs="tableFilterDefs"
                :labels="tableLabels"
                :default-per-page="10"
                :page-options="[10, 15, 20, 50, 100]"
                :narrow="false"
                :table-min-height="500"
                :table-max-height="500"
                @row-clicked="(item) => editTipoActivo(item.id,item.tipo_activo)"
            >
                <template #toolbar-actions>
                    <b-button size="sm" class="table-toolbar-add-btn" @click="createTipoActivo()">
                        {{ labels.addTipoActivo }}
                    </b-button>
                </template>
            </CorporateDataTable>
        </div>
        <div class="row col-md-12 justify-content-center mt-3" v-else>
            <h5>{{ labels.noRow }}</h5> 
        </div>
        <Crear :modalCrear="showTipoActivo" @creado="actualizarTabla" @cierraModal="closeModal"></Crear>
        <Editar 
            :modalEditar="showEditTipoActivo" 
            :infoEdit="dataTipoActivo" 
            :infoCaract="listCaract" 
            @actualizado="actualizarTabla"
            @eliminado="actualizarTabla"
            @cierraModal="closeModal"
        ></Editar>
    </div>
</template>

<script>
import TipoActivo from '../../../services/TipoActivo' 
import TipoActivoCaracteristica from '../../../services/TipoActivoCaracteristica'; 
import CorporateDataTable from '../../utils/CorporateDataTable.vue'
import Crear from './Crear.vue' 
import Editar from './Editar.vue' 
export default {
    name:'TipoActivo',
    components:{Crear, Editar, CorporateDataTable},
    data: () => ({
        tipoActivo : [],
        showTipoActivo : false,
        showEditTipoActivo : false,
        dataTipoActivo : [],
        listCaract : [],
        fields: [
            { key: 'tipo_activo', label: 'Código', sortable: false },
            { key: 'descripcion', label: 'Descripción', sortable: false }
        ],
    }),
    computed:{
        labels(){
            if (this.$store.state._language == "es-ES") { 
                return {
                    title: "Tipo activo",
                    codigo : "Código",
                    descripcion : "Descripción",
                    noRow : "No hay registros",
                    addTipoActivo : "Añadir tipo activo",
                    filterCodigo : "Filtrar código...",
                    filterDescripcion : "Filtrar descripción...",
                }
            }else{
                return {
                    title: "Active type",
                    codigo : "Code",
                    descripcion : "Description",
                    noRow : "There are not records",
                    addTipoActivo : "Add asset type",
                    filterCodigo : "Filter code...",
                    filterDescripcion : "Filter description...",
                }
            }
        },
        allFields(){
            return [
                { key: 'tipo_activo', label: this.labels.codigo, sortable: true, thClass: 'text-center', tdClass: 'text-end' },
                { key: 'descripcion', label: this.labels.descripcion, sortable: true, thClass: 'text-center', tdClass: 'text-start' }
            ]
        },
        tableFilterDefs(){
            return [
                { key: 'tipo_activo', type: 'text', placeholder: this.labels.filterCodigo },
                { key: 'descripcion', type: 'text', placeholder: this.labels.filterDescripcion }
            ]
        },
    },
    methods:{
        goBack() {
            this.$router.back()
        },
        createTipoActivo(){
            this.showTipoActivo = true 
        },
        editTipoActivo(id,tipo_activo){
            // console.log(id,tipo_activo); 
            TipoActivoCaracteristica.getTipoActivoCaractByTipAct(tipo_activo) 
            .then((res) => { 
                // console.log(res.data.tipActCar); 
                this.listCaract = res.data.tipActCar 
            })
            .catch((error) => { console.log(error) }) 

            TipoActivo.getTipoActivoById(id) 
            .then((res) => { 
                // console.log(res.data.tipoActivo) 
                this.dataTipoActivo = res.data.tipoActivo 
                this.showEditTipoActivo = true 
            })
            .catch((err) => { console.log(err)}) 
        },
        closeModal(valor){
            this.showTipoActivo = valor 
            this.showEditTipoActivo = valor 
        },
        actualizarTabla(){
            TipoActivo.getAllTipoActivo() 
            .then((res) => { 
                this.tipoActivo = res.data.listTipoActivo 
            })
            .catch((err) => { console.log(err)})
        }
    },
    mounted(){
        TipoActivo.getAllTipoActivo() 
        .then((res) => { 
            // console.log(res.data.listTipoActivo) 
            this.tipoActivo = res.data.listTipoActivo 
        })
        .catch((err) => { console.log(err)}) 
    }
}
</script>

<style>

</style>
